//reducer : a func that takes in the old state, and an action => new state
import React from 'react'



const contextReducer = (state, action) => {
    
    let transactions;
    switch(action.type){
        case 'DELETE_TRANSACTION':
            transactions = state.filter((transaction) => transaction.id !== action.payload )
            return transactions;

        case 'ADD_TRANSACTION':
            transactions = [action.payload, ...state];

            return transactions;

        default:
            return state;
    }


}

export default contextReducer